import { CancelBtn } from 'components/Button/CancelBtn'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Input } from 'components/Input/Input'
import { Animation, Button, ButtonsContainer, Flex, TabFooter, ThinSeparator } from 'styling/GlobalStyles'
import { IEmployeesTab } from 'types/users.interface'
import { documentCategoryOptions } from './constants'
import { ISelectValue } from 'constants/globalTypes'

export const EmployeesNotesTab = ({ state, setState, handleSubmit }: IEmployeesTab) => {

    const addNote = () => {
        setState({
            ...state,
            notes: [...state.notes, { id: new Date().getMilliseconds(), content: '', visibilityScope: null, category: null }],
        })
    }

    const handleNoteTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>, id: number) => {
        setState({
            ...state,
            notes: state.notes.map(note => note.id === id ? { ...note, content: e.target.value } : note)
        })
    }

    const handleNoteSelect = (value: ISelectValue, name: string, id: number) => {
        setState({
            ...state,
            notes: state.notes.map(note => note.id === id ? { ...note, [name]: value } : note)
        })
    }



    return <Animation>
        <Flex gap='1rem' >
            <Flex column width='100%' gap='1rem' >
                {state.notes.map((note, index) => (
                    <Flex key={index} gap='1rem' column>
                        <Input type='textarea' placeholder='Notes' labelText='Notes' onChange={handleNoteTextChange} value={note.content} height='100px' />
                        <Flex gap='1rem' >
                            <HonestSelectInput nomarg name={`note-visibility-${index}`} options={documentCategoryOptions} labelText='Visibility Scope' onChange={(v, n) => handleNoteSelect(v as ISelectValue, n, note.id)} defaultValue={note.visibilityScope?.value} />
                            <HonestSelectInput nomarg name={`note-category-${index}`} options={documentCategoryOptions} labelText='Category' onChange={(v, n) => handleNoteSelect(v as ISelectValue, n, note.id)} defaultValue={note.category?.value} />
                        </Flex>
                        <ThinSeparator />
                    </Flex>
                ))}
                <Button orange onClick={addNote} >
                    Add Note
                </Button>
            </Flex>
        </Flex>
        <TabFooter  >
            <ButtonsContainer>
                <CancelBtn />
                <Button orange onClick={handleSubmit}>
                    Save
                </Button>
            </ButtonsContainer>
        </TabFooter>
    </Animation>
}